import React from "react";

export default function Section1() {
  return (
    <div className="w-full Section1 ">
      <div className="w-full h-full section1-container ">
        {
          window.innerWidth > 768 ?
          <img
            className="object-contain w-full h-full object-center-center"
            src="../../../../assets/blog-banner.jpg"
            alt="Blogs Background Image"
          ></img> : 
          <img
            className="object-contain w-full h-full object-center-center"
            src="../../../../assets/blogs-banner-mob.jpg"
            alt="Blogs Background Image"
          ></img>
        }
      </div>
    </div>
  );
}
